<ngx-recaptcha2 #captchaElem [siteKey]="siteKey" (expire)="handleExpire()" (success)="handleSuccess($event)"
[size]="size" [hl]="lang" [theme]="theme" [type]="type">
</ngx-recaptcha2>
